import {makeAutoObservable} from "mobx";
import {IUsersService, UsersServiceStoreToken} from "../../../entities/users/api/service";
import {TUserFields} from "../../../lib/api/useTypedPublicEndpoint";
import {ICurrency} from "../../../lib/utils/types";
import {injected, token} from "brandi";
import container from "../../../lib/ioc";

interface IInitialProps {
    userEmail: string
}

interface ISubscriptionContainerModel {
    payingUser: TUserFields | null;

    initial: (props: IInitialProps) => void,
    setPayingUser: (user: TUserFields | null) => void,
}

export default class SubscriptionContainerModel implements ISubscriptionContainerModel {
    private userS: IUsersService;

    payingUser: TUserFields | null = null;

    constructor(userS: IUsersService) {
        this.userS = userS

        makeAutoObservable(this)
    }

    initial(props: IInitialProps) {
        if(props.userEmail) {
            this.userS.getCleanFields({withSubExtra: 1})
                .then(res => {
                    this.setPayingUser(res)
                })
                .catch(e => console.log(e));
        } else {
            this.setPayingUser(null)
        }
    }

    setPayingUser = (user: TUserFields | null) => {
        this.payingUser = user;
    }
}

export const SubscriptionContainerModelToken = token<ISubscriptionContainerModel>('SubscriptionContainerModelToken');

container.bind(SubscriptionContainerModelToken).toInstance(SubscriptionContainerModel).inSingletonScope();

injected(SubscriptionContainerModel, UsersServiceStoreToken);